import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaTh } from 'react-icons/fa';

import { ClickAnywhereElseToCloseCover } from '../AppMenu/components';
import { ClientAppConfig } from '../../../appsConfig';
import appConfig from '../../../appConfig';
import useLocalStorage from '../../../hooks/useLocalstorage';
import { LAST_USED_APP } from '../../../constants/localstorageKeys';
import { dispatchPushUrl } from '../../../utils/eventDispatchers';

const availableApps = appConfig.clientApps;

interface AppSelectorProps {
	isSmallScreen: boolean;
	activeApp: ClientAppConfig;
}

const AppSelector = ({ activeApp, isSmallScreen }: AppSelectorProps) => {
	const [brandSelectionOpen, setBrandSelectionOpen] = React.useState(false);
	const toggleBrandSelectionOpen = React.useCallback(() => setBrandSelectionOpen((isOpen) => !isOpen), []);
	const [, setLastusedProduct] = useLocalStorage(LAST_USED_APP);

	// close app selection when not on small screen
	React.useEffect(() => {
		if (!isSmallScreen) setBrandSelectionOpen(false);
	}, [isSmallScreen]);

	React.useEffect(() => {
		setLastusedProduct(activeApp.name);
	}, [setLastusedProduct, activeApp.name]);

	const onLinkClick = (url: string) => () => {
		setBrandSelectionOpen(false);
		dispatchPushUrl(url);
	};

	return (
		<Wrapper id="app-selector">
			{isSmallScreen && (
				<>
					{availableApps.length > 1 && (
						<SelectBrandButton onClick={toggleBrandSelectionOpen}>
							<FaTh size={18} />
						</SelectBrandButton>
					)}
					<Link to={activeApp.link} onClick={onLinkClick(activeApp.link)}>
						<img src={activeApp.logo.on} alt={activeApp.name} />
					</Link>
					{brandSelectionOpen && (
						<>
							<ClickAnywhereElseToCloseCover
								id="brand"
								onClick={toggleBrandSelectionOpen}
								tabIndex={-1}
								aria-label="toggleMenu"
							/>
							<BrandSelectionContainer>
								{availableApps.map(({ appIcon, name, link }) => (
									<Link key={name} to={link} onClick={onLinkClick(link)}>
										<img src={appIcon} alt={name} />
										<p>{name}</p>
									</Link>
								))}
							</BrandSelectionContainer>
						</>
					)}
				</>
			)}
			{!isSmallScreen &&
				availableApps.map(({ logo, name, link }, i) => (
					<Link key={name} to={link} onClick={onLinkClick(link)}>
						<img src={activeApp?.name === name ? logo.on : logo.off} alt={name} />
					</Link>
				))}
		</Wrapper>
	);
};

export default AppSelector;

const Wrapper = styled.div`
	display: flex;
	align-items: center;

	> a img {
		height: 25px;
	}

	> a:not(:last-of-type) {
		display: inline-block;
		margin-right: 150px;
	}
`;

const SelectBrandButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 32px;
	width: 32px;
	color: ${({ theme }) => theme.colors.white};
	background-color: ${({ theme }) => theme.colors.darkGreyR};
	margin: 0 5px;
	padding: 4px;
	border-radius: 2px;

	&:focus {
		outline: none;
	}
`;

const BrandSelectionContainer = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	position: absolute;
	left: 5px;
	top: 50px;
	height: 120px;
	width: 300px;
	z-index: 50;
	border-radius: 10px;
	color: ${({ theme }) => theme.colors.white};
	background-color: #3b3b3b;

	p {
		font-size: 11px;
	}

	img {
		width: 60px;
		height: 60px;
		margin-bottom: 5px;
	}
`;
